import { ShowOn } from 'component-library/components/wrappers/ShowOn';
import { colors } from 'component-library/styles/colors';
import styled from 'styled-components';

interface OptionsWrapperProps {
  margin?: string;
}

export const OptionsWrapper = styled(ShowOn)<OptionsWrapperProps>`
  background: ${colors.navyBlue};
  border-radius: 24px;
  margin: ${({ margin = 0 }) => margin};
`;
